// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__HOrbw","Icon":"Button_Icon__3NCgl","Inverted":"Button_Inverted__3ld5h"};